export const VALIDATE_UPPERCASE_REGEX = /[A-Z]/
export const VALIDATE_LOWERCASE_REGEX = /[a-z]/
export const VALIDATE_SPECIAL_CHARACTERS_REGEX = /[!#$%&*-@?_~]/
export const VALIDATE_EMAIL_REGEX =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
